var map = {
	"./applemusic.svg": [
		"CuCs",
		22
	],
	"./behance.svg": [
		"Ij9s",
		23
	],
	"./close.svg": [
		"HV5P",
		24
	],
	"./discord.svg": [
		"W/pH",
		25
	],
	"./dribbble.svg": [
		"EEWb",
		26
	],
	"./facebook.svg": [
		"QeRF",
		27
	],
	"./flickr.svg": [
		"M4cN",
		28
	],
	"./instagram.svg": [
		"XiGD",
		29
	],
	"./linkedin.svg": [
		"7pYk",
		30
	],
	"./mail.svg": [
		"sxZP",
		31
	],
	"./pinterest.svg": [
		"9zCd",
		32
	],
	"./soundcloud.svg": [
		"LlUu",
		33
	],
	"./spotify.svg": [
		"TzQ9",
		34
	],
	"./twitch.svg": [
		"yOSY",
		35
	],
	"./twitter.svg": [
		"MvsA",
		36
	],
	"./url.svg": [
		"1dIQ",
		37
	],
	"./whatsapp.svg": [
		"iQNc",
		38
	],
	"./youtube.svg": [
		"i4yc",
		39
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "l5OI";
module.exports = webpackAsyncContext;